import { createSlice } from "@reduxjs/toolkit";
import { editUsers } from "./thunk";
import { toast } from "react-toastify";
export const initialState = {
  user: null,
  error: null,
  editSuccess: null,
};

const UsersSlice = createSlice({
  name: "UsersSlice",
  initialState,
  reducer: {},
  extraReducers: (builder) => {
    builder.addCase(editUsers.pending, (state, action) => {
      toast.dismiss();
      toast.loading("Updating User...", {
        position: "top-center",
        autoClose: false,
      });
      state.error = null;
      state.editSuccess = null;
    });

    builder.addCase(editUsers.fulfilled, (state, action) => {
      state.editSuccess = true;
    });

    builder.addCase(editUsers.rejected, (state, action) => {
      state.editSuccess = false;
    });

    /*
    builder.addCase(addSupplier.fulfilled, (state, action) => {
      state.suppliers.push(action.payload);
    });

    builder.addCase(addSupplier.rejected, (state, action) => {
      state.error = action.payload.error || null;
    });

    builder.addCase(updateSupplier.fulfilled, (state, action) => {
      state.suppliers = state.suppliers.map((supplier) =>
        supplier._id.toString() === action.payload.data._id.toString()
          ? { ...supplier, ...action.payload.data }
          : supplier
      );
    });

    builder.addCase(updateSupplier.rejected, (state, action) => {
      state.error = action.payload.error || null;
    });

    builder.addCase(deleteSupplier.fulfilled, (state, action) => {
      state.suppliers = (state.suppliers || []).filter(
        (supplier) =>
          supplier._id.toString() !== action.payload.supplier.toString()
      );
    });

    builder.addCase(deleteSupplier.rejected, (state, action) => {
      state.error = action.payload.error || null;
    });
    */
  },
});

export default UsersSlice.reducer;
